export default "__VITE_ASSET__DJsBOsRa__"